// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3RVcu","header":"MessagesList_header__2ZDnN","chat":"MessagesList_chat__165MQ"};